import { EmploymentStatusOption } from '@features/applicant';

export const applicantDetailsKey = 'applicantDetails';
export const applicantReferencesKey = 'applicantReferences';
export const availableSlotsKey = 'availableSlotsKey';
export const availableBookedSlotsKey = 'availableBookedSlotsKey';
export const companyAndJobDetailsKey = 'companyAndJobDetails';
export const errorMessage = 'Sorry, something went wrong';

export const employmentStatusOptions: EmploymentStatusOption[] = [
  { text: 'Seeking Employment', value: 'Seeking Employment' },
  {
    text: 'Employed Seeking',
    value: 'Employed Seeking Additional Employment',
  },
  {
    text: 'Not Seeking',
    value: 'Employed Not Seeking Additional Employment',
  },
];

export const months = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];